import { createAsyncThunk } from '@reduxjs/toolkit';
import { postTransferItems } from 'scenes/ProjectBank/services/postTransferItems.service';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';

export const transferItems = createAsyncThunk(
  'projectBank/transferItems',
  async ({ filePermissions = [], targetProjectId, targetParentFilePermissionId }, { getState, rejectWithValue }) => {
    const state = getState();

    const projectId = selectSelectedProjectId(state);
    try {
      const filePermissionIds = filePermissions.map(fp => fp.id)

      const response = await postTransferItems(
        { filePermissionIds, targetProjectId, projectIds: [projectId, targetProjectId], targetParentFilePermissionId },
        projectId
      );

      return response;

    } catch (error) {
      const status = error?.response?.status || 0;
      const data = error?.response?.data || null;
      const message =
        (data && (data.message || data.error)) ||
        error?.message ||
        'Transfer failed';

      return rejectWithValue({ status, message });
    }
  }
);
